import genericStyles from "../../Styles/genericStyles.module.css";
import MUIDataTableCustomStyle from "../../Components/MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState, createContext } from "react";
import { endpoints } from "../../Utils/UrlEnum";
import { AutocompleteChangeReason, Button, Chip } from "@mui/material";
import { ETableEditAction, EWidths } from "../../Utils/Enums";
import GenericModal from "../GenericModal";
import { FormsIds } from "../../Utils/Constants";
import RoleForm from "./RoleForm";

export interface RoleModel {
  _id?: string;
  name: string;
  priority: number;
  allowedRoutes: string[];
  isSystem?: boolean;
}

export const CRUDContext = createContext<RoleModel>({
  name: "",
  priority: 0,
  allowedRoutes: [],
  isSystem: false,
});

export default function RolesTable() {
  const [contextValue, setContextValue] = useState<RoleModel>({
    name: "",
    priority: 0,
    allowedRoutes: [],
    isSystem: false,
  });
  const [open, setOpen] = useState(false);
  const [triggerReload, setTriggerReload] = useState<undefined | boolean>();

  const rolesColumns = [
    {
      label: `${Vocabulary.roleName}`,
      name: "name",
      options: {
        sort: true,
      },
    },
    {
      label: `${Vocabulary.rolePriority}`,
      name: "priority",
      options: {
        sort: true,
      },
    },
    {
      label: `${Vocabulary.systemRole}`,
      name: "isSystem",
      options: {
        sort: true,
        customBodyRender: (value: boolean) => {
          return value ? (
            <Chip label={Vocabulary.yes} color="primary" size="small" />
          ) : (
            <Chip label={Vocabulary.no} color="default" size="small" />
          );
        },
      },
    },
    {
      label: `${Vocabulary.allowedRoutes}`,
      name: "allowedRoutes",
      options: {
        sort: false,
        customBodyRender: (routes: string[]) => {
          return (
            <div>
              {routes && routes.length > 0
                ? `${routes.length} ${Vocabulary.pages.toLowerCase()}`
                : "0 pagini"}
            </div>
          );
        },
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          onEditAction={ETableEditAction.MODAL}
          title={Vocabulary.roles}
          columns={rolesColumns}
          CRUDEndPoint={`${endpoints.rolesEndpoint}`}
          id="rolesTable"
          handleModalForm={setOpen}
          addOrEditForm={
            <GenericModal
              onClose={() => {
                setOpen(false);
                setContextValue({
                  name: "",
                  priority: 0,
                  allowedRoutes: [],
                  isSystem: false,
                });
              }}
              maxWidth={EWidths.MD}
              open={open}
              actions={
                <div className={genericStyles.modalActions}>
                  <Button
                    color="secondary"
                    onClick={() => {
                      setOpen(false);
                      setContextValue({
                        name: "",
                        priority: 0,
                        allowedRoutes: [],
                        isSystem: false,
                      });
                    }}
                    variant="outlined"
                    fullWidth
                  >
                    {Vocabulary.cancel}
                  </Button>
                  <Button
                    fullWidth
                    type="submit"
                    form={FormsIds.roleForm}
                    variant="contained"
                  >
                    {Vocabulary.save}
                  </Button>
                </div>
              }
              title={
                contextValue._id ? Vocabulary.editRole : Vocabulary.createRole
              }
            >
              <RoleForm
                setContextValue={(
                  e: any,
                  role: RoleModel | null,
                  reason: AutocompleteChangeReason,
                  details?: any
                ) => ({})}
                onClose={() => {
                  setOpen(false);
                  setTriggerReload(
                    triggerReload !== undefined ? !triggerReload : false
                  );
                  setContextValue({
                    name: "",
                    priority: 0,
                    allowedRoutes: [],
                    isSystem: false,
                  });
                }}
              />
            </GenericModal>
          }
          setContextValue={setContextValue}
          triggerReload={triggerReload}
        />
      </CRUDContext.Provider>
    </div>
  );
}
